import React, { Component } from "react";
import {
  Icon,
  Dropdown,
  Menu,
  Form,
  InputNumber,
  Input,
  Button,
  Tree,
  message,
  Modal,
} from "antd";
import moment from "moment";
import {
  getTreeData,
  getEcgValue,
  startReport,
  setEcgValue,
} from "@/request/api";
import {
  getRolePrivilegeFn,
  getHeartBeat,
  computeHeartPosition,
  hex2int
} from "../../common/util";
import scaleRulerIcon from "../../assets/image/scaleRulerIcon.svg";
import parallelRulerIcon from "../../assets/image/parallelRulerIcon.svg";
import scaleIcon from "../../assets/image/scaleIcon.png";
import ruler from "../../assets/image/ruler.png";
import positionIcon from '../../assets/image/positionIcon.png'
import "./ecgStartReport.scss";
import ReportView from "./reportView";
import axios from "axios";
import { requestErrorLog } from '@/common/util'
// import dataSource from './dataSource'
const FormItem = Form.Item;
const { TreeNode } = Tree;
const { TextArea } = Input;
class EcgStartReport extends Component {
  state = {
    //走纸速度
    paperSpeed: "25",
    //波形增益
    sensitivity: "10",
    //显示模式
    displayModel: "1",
    //增益mv率
    transmission: 180,
    //采样率
    sampling: 500,
    //视窗的高
    vHeight: 0,
    //心电图的宽
    clientWidth: 0,
    //心电图的高
    clientHeight: 0,
    //显示词库
    thesaurusBtn: false,
    //词库
    treeResult: [],
    //审核值
    reportValue: "",
    //处理后的心电数据
    beatArray: [],
    //心率汇总
    beatsPosition: [],
    //修改心博位置的坐标
    changeHeartIndex: 0,
    //数据是多少导
    ecgLead: 12,
    //数据多少秒
    second: 10,
    //选中的起始值
    startValue: 0,
    //从第几秒开始的数据打印的时候用
    startSecond: 0,
    startPx: 0,
    endValue: 0,
    totalLength: 0,
    //滚动条滚动的距离
    boxLeft: 0,
    //是否显示滚动条
    isShowScrollBar: false,
    R18: [
      "I",
      "II",
      "III",
      "aVR",
      "aVL",
      "aVF",
      "V1",
      "V2",
      "V3",
      "V4",
      "V5",
      "V6",
      "V7",
      "V8",
      "V9",
      "V3R",
      "V4R",
      "V5R",
    ],
    reportViewBtn: false,
    //权限
    PRIVILEGE: "2",
    selectEcgLead: 1,
    //选择开始打印的像素
    startPrint: 0,
    printDirection: 2,
    //是否显示平行尺
    isShowRuler: false,
    //是否显示比例尺
    isShowScaleRuler: false,
    //是否是连续
    isContinuity: false,
    //保留一下比例尺移动最后的的矩形的中心点坐标  [x,y]
    scaleRulerCenterPoint: [],
    //保留一下比例尺缩放最后的大小
    scaleRulerSize: [100, 80],
    positionMark: false,
    averageData: {
      "I": [],
      "II": [],
      "III": [],
      "aVR": [],
      "aVL": [],
      "aVF": [],
      "V1": [],
      "V2": [],
      "V3": [],
      "V4": [],
      "V5": [],
      "V6": [],
      // "V7": [],
      // "V8": [],
      // "V9": [],
      // "V3R": [],
      // "V4R": [],
      // "V5R": [],
    },
    averageActiveLead: 'ALL',
    markPositionObj: {
      PB: -150,
      PE: -100,
      QB: -50,
      SE: 30,
      TB: 100,
      TE: 150,
    },
  };
  componentDidMount() {
    this.getEcgData();
    window.onresize = this.onResize;
    this.thesaurusTreeData();
    window.addEventListener("mousewheel", this.changeDOMMouseScroll, false);
    // this.changeDOMMouseScroll()
    this.getEcgValue();
    this.chooseStartPrintTime();
    let PRIVILEGE = getRolePrivilegeFn();
    let printDirection = localStorage.getItem("printDirection") || 1;
    this.setState({
      PRIVILEGE,
      reportValue: this.props.rowData.CONCLUSIONS,
      printDirection,
    });
  }
  //选择开始打印的时间标记
  chooseStartPrintTime = () => {
    let startPrint = document.getElementById("startPrint");
    let changeHeartBox = document.getElementById('changeHeartBox')
    startPrint.oncontextmenu = e => e.preventDefault()
    startPrint.onmousedown = (e) => {
      let isTrue = this.isHeartPosition(e)
      if (e.button === 0) {
        if (isTrue[0]) {
          this.drawChangeHeaetBg(startPrint, isTrue[1])
        }
      }
      if (e.button === 2) {
        changeHeartBox.style.left = e.clientX + 'px';
        changeHeartBox.style.top = e.clientY - 75 + 'px';
        this.setState({
          startPx: e.clientX
        })
        if (isTrue[0]) {
          this.drawChangeHeaetBg(startPrint, isTrue[1])
        }
      } else {
        changeHeartBox.style.left = '-120px';
        changeHeartBox.style.top = '-30px';
      }
    };
  };
  //判断鼠标按下的位置是否在心博位置
  isHeartPosition = (e) => {
    let pointX = this.handleBeatsPosition();
    let isTrue = false;
    let x = 0;
    let index = 0;
    for (let i = 1; i < pointX.length; i++) {
      if (pointX[i] - 5 < e.clientX && e.clientX < pointX[i] + 5) {
        isTrue = true
        //把最小的x轴的位置抛出去
        x = pointX[i] - 5
        index = i
      }
    }
    this.setState({
      changeHeartIndex: index,
    })
    return [isTrue, x]
  }
  //修改心博位置
  changeHeartFn = (value) => {
    let { beatsPosition, changeHeartIndex } = this.state;
    let changeHeartBox = document.getElementById('changeHeartBox')
    changeHeartBox.style.left = '-120px';
    changeHeartBox.style.top = '-30px';
    if (changeHeartIndex <= 0) return;
    beatsPosition[changeHeartIndex].HeartBeat = value;
    this.drawGrid();
    this.setState({
      startPrint: 0,
      startSecond: 0,
    });
    console.log(this.state.beatsPosition, this.state.changeHeartIndex)
  }
  //绘制开始打印标记的canvas
  drawStartPoint = () => {
    let pointX = this.state.startPx;
    let paperSpeed = this.state.paperSpeed * 5;
    let startSecond = (this.state.startValue + pointX - 25) / paperSpeed;
    let startPrint = document.getElementById('startPrint')
    let changeHeartBox = document.getElementById('changeHeartBox')
    changeHeartBox.style.left = '-120px';
    changeHeartBox.style.top = '-30px';
    if (startPrint.getContext) {
      let ctx = startPrint.getContext("2d");
      ctx.clearRect(0, 0, this.state.clientWidth, this.state.clientHeight);
      ctx.beginPath();
      ctx.moveTo(pointX - 10, 0);
      ctx.lineTo(pointX + 10, 0);
      ctx.lineTo(pointX, 10);
      ctx.fillStyle = "blue";
      ctx.closePath();
      ctx.fill();

      ctx.beginPath();
      ctx.strokeStyle = "blue";
      for (let i = 10; i < this.state.clientHeight; i += 10) {
        ctx.moveTo(pointX, i);
        ctx.lineTo(pointX, i + 5);
        ctx.stroke();
      }
      ctx.closePath();
    }
    this.setState({
      startPrint: pointX,
      startSecond,
    });
  }
  //绘制可以修改心博位置的背景canvas
  drawChangeHeaetBg = (startPrint, x) => {
    if (startPrint.getContext) {
      let ctx = startPrint.getContext("2d");
      ctx.clearRect(0, 0, this.state.clientWidth, this.state.clientHeight);
      ctx.beginPath();
      ctx.rect(x, 0, 11, this.state.clientHeight)
      ctx.stroke()
      ctx.fillStyle = '#0000ff1f';
      ctx.fill();
      ctx.closePath()
    }
  }
  //处理心博位置数据改变成像素位置
  handleBeatsPosition = () => {
    let { startValue, beatsPosition, sampling, paperSpeed } = this.state;
    //根据走纸速度和采样率选择我应该取的值，算出来步进
    let speed = sampling / (paperSpeed * 5);
    //需要画的标志的x轴的位置
    let pointX = [];
    beatsPosition.forEach((item) => {
      pointX.push(Math.round(item.Position / speed) + 25.5 - startValue);
    });
    return pointX
  }
  changeSizeRepeat = () => {
    let startPrintCanvas = document.getElementById("startPrint");
    let { startSecond, clientHeight, clientWidth, paperSpeed, startValue } =
      this.state;
    let startPrint = startSecond * paperSpeed * 5 - startValue + 25;
    this.setState({
      startPrint,
    });
    if (startPrintCanvas.getContext) {
      let ctx = startPrintCanvas.getContext("2d");
      ctx.clearRect(0, 0, clientWidth, clientHeight);
      ctx.beginPath();
      ctx.moveTo(startPrint - 10, 0);
      ctx.lineTo(startPrint + 10, 0);
      ctx.lineTo(startPrint, 10);
      ctx.fillStyle = "blue";
      ctx.closePath();
      ctx.fill();

      ctx.beginPath();
      ctx.strokeStyle = "blue";
      for (let i = 10; i < this.state.clientHeight; i += 10) {
        ctx.moveTo(startPrint, i);
        ctx.lineTo(startPrint, i + 5);
        ctx.stroke();
      }
      ctx.closePath();
    }
  };
  onResize = (e) => {
    let vHeight = document.documentElement.clientHeight;
    let ecgCanvas = document.getElementById("ecgCanvas");
    let {
      clientWidth,
      clientHeight,
      isShowScrollBar,
      paperSpeed,
      second,
      boxLeft,
      totalLength,
      sampling,
      displayModel,
    } = this.state;
    displayModel = parseInt(displayModel);
    if (ecgCanvas) {
      clientWidth = ecgCanvas.offsetWidth;
      //判断是否出现滚动条
      paperSpeed = paperSpeed * 5;
      //如果总秒数乘以走纸速度需要的距离大于每一导给定的距离那么就显示滚动条
      if (second * paperSpeed > clientWidth / displayModel) {
        isShowScrollBar = true;
        clientHeight = vHeight - 110;
      } else {
        isShowScrollBar = false;
        clientHeight = vHeight - 90;
      }
    }
    //如果不显示滚动条了，就把左边的距离给更新归零，从数据第0位开始画
    if (!isShowScrollBar) {
      boxLeft = 0;
    }
    this.setState(
      {
        vHeight,
        clientWidth,
        clientHeight,
        isShowScrollBar,
        boxLeft,
      },
      () => {
        this.drawGrid();
        this.changeSizeRepeat();
        if (isShowScrollBar) {
          let scale =
            (clientWidth / displayModel - 25) /
            (totalLength / (sampling / paperSpeed));
          let box = document.getElementById("scrollBar");
          box.style.width = (clientWidth - 25) * scale + "px";
          this.changeCustomScrollBar();
        }
        if (this.state.isShowScaleRuler) {
          this.drawScaleRuler()
        }
      }
    );
  };
  componentWillUnmount() {
    window.onresize = null;
  }
  /************心电图开始***************/
  //获取心电图数据
  getEcgData = () => {
    const { rowData } = this.props;
    let EXAM_UID = rowData.EXAM_UID;
    axios({
      method: "get",
      url:
        window.g.baseURL +
        "/api/ECGDataFiles/GetECGDataFile?strExamUID=" +
        EXAM_UID,
      responseType: "blob",
    }).then((res) => {
      if (res.status === 200) {
        var blob = new Blob([res.data]);
        var fr = new FileReader();
        fr.addEventListener("load", (ev) => {
          var abb = ev.target.result;
          var iAA = new Int8Array(abb);
          //心电采样率
          let sampling = (iAA[9] << 8) | (iAA[8] & 255);
          //心电导联数
          let ecgLead = iAA[10];
          //1mv数据值(增益率)
          let transmission = (iAA[12] << 8) | (iAA[11] & 255);
          //数据长度（多少秒）拿到数据是毫秒，直接换算成秒
          // let second = iAA.slice(13, 17).join('') / 1000;
          // let second = (((iAA[16] << 8) | (iAA[15] & 255)) << 8) | (((iAA[14] << 8) | (iAA[13] & 255)) & 255)
          let second =
            (iAA[13] | (iAA[14] << 8) | (iAA[15] << 16) | (iAA[16] << 24)) /
            1000;
          let dataSource = iAA.slice(512);
          let beatArray = [];
          let arr = [];
          //首先根据字节转换成数据
          for (let i = 0; i < dataSource.length; i += 2) {
            arr.push((dataSource[i + 1] << 8) | (dataSource[i] & 255));
          }
          //看看多少个导联创建多少个空数组等待接收
          for (let i = 0; i < ecgLead; i++) {
            beatArray.push([]);
          }
          //根据导联分别取出数据
          for (let i = 0; i < arr.length; i += ecgLead) {
            for (let j = 0; j < ecgLead; j++) {
              beatArray[j].push(arr[j + i]);
            }
          }
          // console.log(sampling, '心电采样率')
          // console.log(ecgLead, '心电导联数')
          // console.log(transmission, '1mv数据值')
          // console.log(second, '秒数')
          // console.log(beatArray, '解析后的数组')
          this.setState(
            {
              beatArray,
              totalLength: beatArray[0].length,
              sampling,
              ecgLead,
              transmission,
              second,
            },
            () => {
              this.drawGrid();
              this.onResize();
            }
          );
        });
        fr.readAsArrayBuffer(blob);
      }
    }).catch(err => {
      requestErrorLog('', '获取心电图数据报错:' + JSON.stringify(window.g.baseURL + "/api/ECGDataFiles/GetECGDataFile?strExamUID=" + EXAM_UID), 0, false)
    });
  };
  //获取分析数据
  getEcgValue = () => {
    let EXAM_UID = this.props.rowData ? this.props.rowData.EXAM_UID : "";
    getEcgValue(EXAM_UID).then((res) => {
      if (res && res.Status === 1) {
        if (res.Result) {
          let item = res.Result[0];
          let { setFieldsValue } = this.props.form;
          setFieldsValue({
            HEARTRATE: item.HEARTRATE, //心率
            TDURATION: item.TDURATION, //T波宽度(ms)
            RV5: item.RV5, //RV5(mV)
            PDURATION: item.PDURATION, //P波宽度(ms)
            QRSDURATION: item.QRSDURATION, //QRS波宽度(ms)
            PRINTERAL: item.PRINTERAL, //PR间期
            QTINTERAL: item.QTINTERAL, //QT间期
            QTCINTERAL: item.QTCINTERAL, //QTc间期
            RV5SV1: item.RV5SV1, //RV5SV1
            PAXIS: item.PAXIS, //P电轴
            SV1: item.SV1, //SV1
            QRSAXIS: item.QRSAXIS, //QRS电轴
            RRINTERAL: item.RRINTERAL, //RR间期
            TAXIS: item.TAXIS, //T电轴
          });
          this.setState({
            beatsPosition: item.BEATS_POSITION
              ? JSON.parse(item.BEATS_POSITION)
              : [],
            averageData: item.AVE_WAVE ? JSON.parse(item.AVE_WAVE) : {},
            reportValue: item.AUTOMATIC_DIAGNOSIS,
          }, () => {
            this.drawGrid();
          });
        }
      }
    });
  };
  drawGrid = () => {
    let myCanvas = document.getElementById("ecg");
    if (myCanvas.getContext) {
      let ctx = myCanvas.getContext("2d");
      let { clientHeight, clientWidth } = this.state;
      ctx.clearRect(0, 0, clientWidth, clientHeight);
      this.drawBigGrid(ctx, clientWidth, clientHeight);
      this.drawLine(ctx, clientWidth, clientHeight);
      this.drawSign(ctx, clientHeight, clientWidth);
      this.drawBeats(ctx, clientWidth);
    }
  };
  //utf-8字节转字符
  utf8ByteToUnicodeStr = (utf8Bytes) => {
    var unicodeStr = "";
    for (var pos = 0; pos < utf8Bytes.length;) {
      var flag = utf8Bytes[pos];
      var unicode = 0;
      if (flag >>> 7 === 0) {
        unicodeStr += String.fromCharCode(utf8Bytes[pos]);
        pos += 1;
      } else if ((flag & 0xfc) === 0xfc) {
        unicode = (utf8Bytes[pos] & 0x3) << 30;
        unicode |= (utf8Bytes[pos + 1] & 0x3f) << 24;
        unicode |= (utf8Bytes[pos + 2] & 0x3f) << 18;
        unicode |= (utf8Bytes[pos + 3] & 0x3f) << 12;
        unicode |= (utf8Bytes[pos + 4] & 0x3f) << 6;
        unicode |= utf8Bytes[pos + 5] & 0x3f;
        unicodeStr += String.fromCharCode(unicode);
        pos += 6;
      } else if ((flag & 0xf8) === 0xf8) {
        unicode = (utf8Bytes[pos] & 0x7) << 24;
        unicode |= (utf8Bytes[pos + 1] & 0x3f) << 18;
        unicode |= (utf8Bytes[pos + 2] & 0x3f) << 12;
        unicode |= (utf8Bytes[pos + 3] & 0x3f) << 6;
        unicode |= utf8Bytes[pos + 4] & 0x3f;
        unicodeStr += String.fromCharCode(unicode);
        pos += 5;
      } else if ((flag & 0xf0) === 0xf0) {
        unicode = (utf8Bytes[pos] & 0xf) << 18;
        unicode |= (utf8Bytes[pos + 1] & 0x3f) << 12;
        unicode |= (utf8Bytes[pos + 2] & 0x3f) << 6;
        unicode |= utf8Bytes[pos + 3] & 0x3f;
        unicodeStr += String.fromCharCode(unicode);
        pos += 4;
      } else if ((flag & 0xe0) === 0xe0) {
        unicode = (utf8Bytes[pos] & 0x1f) << 12;
        unicode |= (utf8Bytes[pos + 1] & 0x3f) << 6;
        unicode |= utf8Bytes[pos + 2] & 0x3f;
        unicodeStr += String.fromCharCode(unicode);
        pos += 3;
      } else if ((flag & 0xc0) === 0xc0) {
        //110
        unicode = (utf8Bytes[pos] & 0x3f) << 6;
        unicode |= utf8Bytes[pos + 1] & 0x3f;
        unicodeStr += String.fromCharCode(unicode);
        pos += 2;
      } else {
        unicodeStr += String.fromCharCode(utf8Bytes[pos]);
        pos += 1;
      }
    }
    return unicodeStr;
  };
  //背景网格
  drawBigGrid = (ctx, width, height, bool) => {
    let { startValue } = this.state;
    //计算出来开始的这个值是在第几位，一个大的表格算一个余数如果为0，那么就证明大网格的竖线可以开始画否则就是小网格,取负数是因为他按照一个大格开始走过了几个
    let bigStartValue = 0 - ((startValue % 25) + 0.5);
    //从这个负数开始计算，每隔25个像素画一条竖线
    for (let x = bigStartValue; x <= width; x += 25) {
      ctx.beginPath();
      ctx.lineWidth = 1;
      ctx.strokeStyle = "#FF6464";
      ctx.moveTo(x, 0);
      ctx.lineTo(x, height);
      ctx.stroke();
      ctx.closePath();
    }
    //画的小点点，每5个像素就应该画了
    for (let x = bigStartValue; x <= width; x += 5) {
      //计算一下，如果他画了大网格的竖线，就不用画小点点了
      if ((x + bigStartValue) % 25 !== 0) {
        ctx.beginPath();
        ctx.lineWidth = 1;
        ctx.strokeStyle = "#FFB4B4";
        //每隔5个像素画一点
        for (let z = 0; z <= height; z += 5) {
          //留出来大网格横线的位置可以不用重复画
          if (z % 25 !== 0) {
            ctx.moveTo(x + 1, z + 1);
            ctx.lineTo(x - 1, z - 1);
          }
        }
        ctx.stroke();
        ctx.closePath();
      }
    }
    //横线的位置每次都是一样的从0开始每隔25像素画一条
    for (let y = 0.5; y <= height; y += 25) {
      ctx.beginPath();
      ctx.lineWidth = 1;
      ctx.strokeStyle = "#FF6464";
      ctx.moveTo(0, y);
      ctx.lineTo(width, y);
      ctx.stroke();
      ctx.closePath();
    }
    //画完网格画最下方的秒数
    if (!bool) {
      this.drawSeconds(ctx, width, height);
    }
  };
  //最下方的秒数
  drawSeconds = (ctx, width, height) => {
    let { paperSpeed, startValue } = this.state;
    //*=5是按照5个像素为一格计算
    paperSpeed *= 5;
    ctx.beginPath();
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 1;
    //根据走纸速度和需要开始画的值，计算出现在从第几秒开始画
    var second = parseInt(startValue / paperSpeed);
    //前面的25.5像素是定波方标的位置，不算在里面，上一步已经算出来从第几秒开始画，这一步算出来余数往前推一下算出来开始的x轴位置
    var startX = -(startValue % paperSpeed) + 25.5;
    for (let i = startX; i < width; i += paperSpeed) {
      ctx.font = "13px '微软雅黑'";
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(
        second.toString().length < 2 ? "00:0" + second : "00:" + second,
        i + 3,
        height - 10
      );
      ctx.fillRect(i - 2, height - 20, 3, 15);
      second++;
    }
    //右上角的显示现在选择的走纸速度和增益
    ctx.textAlign = "right";
    ctx.font = "16px '微软雅黑'";
    ctx.fillText(
      this.state.paperSpeed + "mm/s     " + this.state.sensitivity + "mm/mv",
      width - 30,
      height - 30
    );
    ctx.closePath();
  };
  //最上面的心率位置
  drawBeats = (ctx, width) => {
    let { beatsPosition, sampling } = this.state;
    let pointX = this.handleBeatsPosition();
    for (let i = 1; i <= pointX.length; i++) {
      let x = pointX[i];
      let y = pointX[i - 1];
      let heartX = (x - y) / 2 + y;
      if (x <= width && x > 25.5) {
        ctx.font = "10px";
        ctx.fillStyle = "#000";
        ctx.textAlign = "center";
        ctx.fillText(getHeartBeat(beatsPosition[i].HeartBeat), x, 15);
        let position = computeHeartPosition(
          beatsPosition[i - 1].Position,
          beatsPosition[i].Position,
          sampling
        );
        ctx.fillText(position[0], heartX, 15);
        ctx.fillText(position[1], heartX, 30);
      }
    }
  };
  //画线
  drawLine = (ctx, width, height) => {
    let {
      paperSpeed,
      sensitivity,
      displayModel,
      beatArray,
      transmission,
      sampling,
      startValue,
      totalLength,
      ecgLead,
      clientWidth,
    } = this.state;
    //根据数据给我的1mv的高度和选择的增益算出来我在屏幕上应该显示多高百分比
    transmission = (sensitivity * 5) / transmission;
    //根据走纸速度和采样率选择我应该取的值，算出来步进
    let speed = sampling / (paperSpeed * 5);

    //如果显示加1模式则下面5行代码有效
    let addEcg = 0;
    if (displayModel.length > 3) {
      addEcg = 1;
    }
    displayModel = parseInt(displayModel);

    //现在一列显示几导
    let nowLead = ecgLead / displayModel;
    //每一导可以占据的高度
    let vHeight = height / (nowLead + 1 + addEcg);
    //初始化一下可以画的宽度
    let endWidth = 0;
    //初始化定义一个各导联初始值,并且第一个值跟随页面变化后续变化都跟初始化的值有关
    let initStarValue = [this.state.startValue];
    //第一个循环是循环多少导，画几条数据
    for (let i = 0; i < beatArray.length; i++) {
      let arr = [];
      //根据刚才的步进取值arr里面就是我需要画的每个数据
      for (let x = 0; x < beatArray[i].length; x += speed) {
        arr.push(beatArray[i][x]);
      }
      //这一导在y轴的开始位置
      let speedHeight = vHeight * (i % nowLead) + vHeight;
      //x轴的初始位置
      let pointX = 25.5;
      //这里没想好怎么优化两个if判断一下显示模式不一样x轴的初始位置
      if (i >= nowLead && i < nowLead * 2) {
        pointX = clientWidth / displayModel + 25.5;
      } else if (i >= nowLead * 2) {
        pointX = (clientWidth / displayModel) * 2 + 25.5;
      }
      //根据显示模式算出来最终可以在屏幕上画的宽度
      if (i % nowLead === 0) {
        endWidth += width / displayModel;
      }
      ctx.beginPath();
      ctx.strokeStyle = "#000";
      ctx.lineWidth = 1.3;
      ctx.lineCap = "square";
      ctx.lineJoin = "round";
      //移动到初始位置
      ctx.moveTo(pointX, speedHeight + arr[startValue] * transmission);
      //循环，只要是数据还有或者宽度没有到达指定结尾就一直画
      while (startValue < totalLength && pointX < endWidth) {
        //因为给的值是从0开始的，但是我们y轴的位置不是从0开始的所以就需要我们的y轴的值加上我们拿到的值乘以我们刚才根据1mv的值和增益和屏幕的像素算出来的百分比
        ctx.lineTo(pointX, speedHeight + arr[startValue] * transmission);
        pointX++;
        startValue++;
      }
      //不能跟上面一块写是因为宽度需要画线开始确定，而下一列的初始值需要前一列画完才知道
      if ((i + 1) % nowLead === 0 && this.state.isContinuity) {
        initStarValue.push(startValue);
      }
      //如果不是连续的画完一导以后把初始值给初始化一下，留给下一导接着画
      if (!this.state.isContinuity) {
        startValue = initStarValue[0];
      } else {
        // 如果是连续的就需要分批才可以初始化,就需要第一列是从0开始，第二列从第一列画完的开始初始化，第三列从第二列画完开始初始化
        if (i <= nowLead - 2) {
          startValue = initStarValue[0];
        } else if (i < nowLead * 2 - 1) {
          startValue = initStarValue[1] + 25;
        } else {
          startValue = initStarValue[2] + 25;
        }
      }
      ctx.stroke();
      ctx.closePath();
    }
    if (addEcg === 1) {
      let arr = [];
      for (let x = 0; x < totalLength; x += speed) {
        arr.push(beatArray[this.state.selectEcgLead][x]);
        //  var arr1 = this.processingValue(beatArray[this.state.selectEcgLead].slice(x,x+speed+1));
        // arr = arr.concat(arr1)
      }
      let speedHeight = vHeight * nowLead + vHeight;
      let pointX = 25.5;
      ctx.beginPath();
      ctx.strokeStyle = "#000";
      ctx.lineWidth = 1.2;
      ctx.miterLimit = 1;
      ctx.lineJoin = "round";
      ctx.lineCap = "round";
      //最后加一导要从初始值开始加
      startValue = this.state.startValue;
      ctx.moveTo(pointX, speedHeight + arr[startValue] * transmission);
      while (startValue < totalLength && pointX < width) {
        //因为给的值是从0开始的，但是我们y轴的位置不是从0开始的所以就需要我们的y轴的值加上我们拿到的值乘以我们刚才根据1mv的值和增益和屏幕的像素算出来的百分比
        ctx.lineTo(pointX, speedHeight + arr[startValue] * transmission);
        pointX++;
        startValue++;
      }
      ctx.stroke();
      ctx.closePath();
    }
  };
  //定波方标
  drawSign = (ctx, height, width) => {
    let { R18, sensitivity, ecgLead, displayModel } = this.state;
    let addEcg = 0;
    if (displayModel.length > 3) {
      addEcg = 1;
    }
    displayModel = parseInt(displayModel);
    let nowLead = ecgLead / displayModel;
    //改变展示模式后六个开始的坐标
    let startPointX = -width / displayModel;
    ctx.beginPath();
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 1;
    //每一导的高度固定，
    let pointYHeight = height / (nowLead + 1 + addEcg);
    sensitivity *= 5;
    //循环导数，添加定波方标
    for (let i = 0; i < ecgLead; i++) {
      //确定每个方标在y轴的位置
      let pointY = (i % nowLead) * pointYHeight + pointYHeight;
      if (i % nowLead === 0) {
        startPointX += width / displayModel;
      }
      ctx.moveTo(startPointX, pointY);
      ctx.lineTo(startPointX + 5, pointY); //向右
      ctx.lineTo(startPointX + 5, pointY - sensitivity); //向上
      ctx.lineTo(startPointX + 15, pointY - sensitivity); //向右
      ctx.lineTo(startPointX + 15, pointY); //向下
      ctx.lineTo(startPointX + 20, pointY); //向右
      ctx.stroke();
      ctx.font = "14px '微软雅黑'";
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(R18[i], startPointX + 20, pointY - 30);
    }
    ctx.closePath();
    if (addEcg === 1) {
      let pointY = nowLead * pointYHeight + pointYHeight;
      ctx.moveTo(0, pointY);
      ctx.lineTo(5, pointY); //向右
      ctx.lineTo(5, pointY - sensitivity); //向上
      ctx.lineTo(15, pointY - sensitivity); //向右
      ctx.lineTo(15, pointY); //向下
      ctx.lineTo(20, pointY); //向右
      ctx.stroke();
      ctx.font = "14px '微软雅黑'";
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(R18[this.state.selectEcgLead], 20, pointY - 30);
    }
  };
  //走纸速度
  handlePaperClick = (e) => {
    if (this.state.isShowScrollBar) {
      let box = document.getElementById("scrollBar");
      box.style.left = "0px";
    }
    this.setState(
      {
        paperSpeed: e.key,
        boxLeft: 0,
        startValue: 0,
      },
      () => {
        this.onResize();
      }
    );
  };
  //波形增益
  handleWaveClick = (e) => {
    this.setState(
      {
        sensitivity: e.key,
      },
      () => {
        this.drawGrid();
      }
    );
  };
  //显示模式
  handleMenuClick = (e) => {
    let isContinuity = false;
    //根据定义的key值，来判断是否选择的是连续模式
    if (e.key.length === 3 || e.key.length === 5) {
      isContinuity = true;
    }
    this.setState(
      {
        displayModel: e.key,
        isContinuity,
      },
      () => {
        this.onResize();
      }
    );
  };
  //导联选择
  handleEcgLeadClick = (e) => {
    this.setState(
      {
        selectEcgLead: e.key,
      },
      () => {
        this.onResize();
      }
    );
  };
  //打印方向
  handleDirectionClick = (e) => {
    this.setState(
      {
        printDirection: e.key,
      },
      () => {
        localStorage.setItem("printDirection", e.key);
      }
    );
  };
  //自定义的显示横向滚动条
  changeCustomScrollBar = () => {
    let box = document.getElementById("scrollBar");
    let wrap = document.getElementById("wrap");
    let { clientWidth, totalLength, sampling, paperSpeed, displayModel } =
      this.state;
    displayModel = parseInt(displayModel);
    clientWidth /= displayModel;
    //给绿色的div添加onmousedown事件
    box.onmousedown = (ev) => {
      let e = ev || window.event;
      //计算出鼠标按下的点到box的左侧边缘和上侧边缘
      let restLeft = e.clientX - wrap.offsetLeft - box.offsetLeft;
      // 针对低版本IE的方法，setCapture方法在oBox元素和下面的元素中间添加了一个透明层
      if (box.setCapture) {
        box.setCapture();
      }
      //移动的时候计算left和top值，每次移动都会生效
      document.onmousemove = (ev) => {
        let e = ev || window.event;
        //计算出left值和top值
        let boxLeft = e.clientX - restLeft - wrap.offsetLeft;
        //限制范围
        let maxLeft = wrap.offsetWidth - box.offsetWidth;
        let minLeft = 0;
        if (boxLeft < minLeft) {
          boxLeft = minLeft;
        }
        if (boxLeft > maxLeft) {
          boxLeft = maxLeft;
        }
        //设置left，top值
        box.style.left = boxLeft + "px";
        //算出来开始的值，数据总数/(采样率/(走纸速度*5))算出来是每个数据占据页面的比例乘以滚动条离左边的距离的比例，就是开始的值
        let startValue = parseInt(
          (totalLength / (sampling / (paperSpeed * 5))) *
          (boxLeft / clientWidth / displayModel)
        );
        this.setState(
          {
            startValue,
            boxLeft,
          },
          () => {
            this.drawGrid();
          }
        );
      };
      document.onmouseup = () => {
        //销毁onmousemove和onmouseup事件
        document.onmousemove = null;
        document.onmouseup = null;
        // 去掉透明层
        if (box.releaseCapture) {
          box.releaseCapture();
        }
      };
      //阻止浏览器默认行为
      return false;
    };
  };
  //监听鼠标滚轮事件
  changeDOMMouseScroll = (ev) => {
    if (this.state.isShowScrollBar) {
      let { boxLeft, totalLength, sampling, clientWidth, displayModel, paperSpeed } = this.state;
      let box = document.getElementById('scrollBar');
      if (!box) return
      let wrap = document.getElementById("wrap");
      let maxLeft = wrap.offsetWidth - box.offsetWidth;
      let minLeft = 0;
      if (ev.wheelDelta > 0) {
        boxLeft -= 30
        if (boxLeft < minLeft) boxLeft = minLeft;
      } else {
        boxLeft += 30
        if (boxLeft > maxLeft) boxLeft = maxLeft;
      }
      box.style.left = boxLeft + 'px'
      let startValue = parseInt(
        (totalLength / (sampling / (paperSpeed * 5))) *
        (boxLeft / clientWidth / displayModel)
      );
      this.setState({
        boxLeft,
        startValue
      }, () => {
        this.drawGrid();
      })
    }
  };

  /************心电图结束***************/

  // 获取树的内容
  thesaurusTreeData() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    let params = {
      Type: "HOSPITALTreeData",
      Hospital_code: userInfo.HOSPITAL_CODE,
    };
    getTreeData(params).then((res) => {
      if (res && res.Status === 1) {
        let treeData = res.Result;
        this.setState({
          treeResult: treeData,
        });
      } else {
        message.error("请检查网络连接");
      }
    });
  }
  renderTreeNodes = (data) =>
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode
            title={item.HELPER_NAME}
            key={item.HELPER_CODE}
            uid={item.REPORT_HELPER_UID}
          >
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          title={item.HELPER_NAME}
          key={item.HELPER_CODE}
          uid={item.REPORT_HELPER_UID}
        />
      );
    });
  //打开或隐藏词库面板
  changeThesaurusFn = () => {
    this.setState({
      thesaurusBtn: !this.state.thesaurusBtn,
    });
  };
  //选中词库添加到结论里
  selectTreeNodeFn = (name, info) => {
    //最保存最后一级选中的内容，有子集就不选父级
    if (info.node.props.children.length === 0) {
      this.setState({
        reportValue: this.state.reportValue + info.node.props.title,
      });
    }
  };
  //改变结论
  changeReportValue = (e) => {
    this.setState({
      reportValue: e.target.value,
    });
  };
  //报告打印
  checkReportView = () => {
    if (this.props.rowData.EXAM_STATUS_NAME === "已审核") {
      this.setState({
        reportViewBtn: true,
      });
      // let { startPrint, displayModel, clientWidth } = this.state;
      // if (startPrint > clientWidth / parseInt(displayModel)) {
      //   startPrint -= clientWidth / parseInt(displayModel)
      // }
      // let startSecond = (startValue + startPrint - 25) / (paperSpeed * 5);
    } else {
      message.error("该病例未审核");
    }
  };
  cancalReportView = () => {
    this.setState({
      reportViewBtn: false,
    });
  };
  //审核/报告结论
  startReport = () => {
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    let EXAM_UID = this.props.rowData ? this.props.rowData.EXAM_UID : "";
    let params = {
      EXAM_UID,
      DOCTOR_NAME: userInfo.REAL_NAME,
      DOCTOR_CODE: userInfo.USER_UID,
      DATETIME: moment().format("YYYY-MM-DD HH:mm:ss"),
      CONCLUSIONS: this.state.reportValue,
      EXAM_STATUS: this.state.PRIVILEGE === "0" ? 2 : 3,
    };
    if (this.state.PRIVILEGE === "0") {
      params.Type = "submit";
    } else {
      params.Type = "report";
    }
    startReport(params).then((res) => {
      if (res && res.Status === 1) {
        this.props.refreshTable();
        this.changeEcgValue(EXAM_UID, userInfo);
      }
    });
  };
  //修改解析的数据
  changeEcgValue = (EXAM_UID, userInfo) => {
    this.props.form.validateFields((err, value) => {
      if (!err) {
        let params = {
          EXAM_UID,
          EDIT_OPERATOR_UID: userInfo.USER_UID,
          EDIT_DATE: moment().format("YYYY-MM-DD HH:mm:ss"),
          ...value,
        };
        setEcgValue(params).then((res) => {
          if (res && res.Status === 1) {
            // this.props.refreshTable();
            if (this.state.PRIVILEGE === "0") {
              message.success("报告成功");
            } else {
              message.success("审核成功");
            }
          }
        });
      }
    });
  };
  //是否显示平行尺
  changeShowParallelRulerFn = () => {
    this.setState({
      isShowRuler: !this.state.isShowRuler,
    }, () => {
      this.moveRuler()
      if (this.state.isShowRuler && this.state.isShowScaleRuler) {
        this.setState({
          isShowScaleRuler: false,
        });
      }
    });
  };
  //移动平行尺
  moveRuler = () => {
    let ruler = document.getElementById('ruler');
    if (!ruler) return;
    ruler.onmousedown = (ev) => {
      let e = ev || window.event;
      let restLeft = e.clientX - ruler.offsetLeft;
      let restTop = e.clientY - ruler.offsetTop;
      document.onmousemove = (ev) => {
        let e = ev || window.event;
        let boxLeft = e.clientX - restLeft;
        let boxTop = e.clientY - restTop
        ruler.style.left = boxLeft + "px";
        ruler.style.top = boxTop + 'px';
      }
      document.onmouseup = () => {
        //销毁onmousemove和onmouseup事件
        document.onmousemove = null;
        document.onmouseup = null;
        // 去掉透明层
        if (ruler.releaseCapture) {
          ruler.releaseCapture();
        }
      };
      return false;
    }
  }
  //是否显示比例尺
  changeShowScaleRulerFn = () => {
    this.setState({
      isShowScaleRuler: !this.state.isShowScaleRuler,
      scaleRulerCenterPoint: [],
      scaleRulerSize: [100, 80],
    }, () => {
      this.drawScaleRuler()
      if (this.state.isShowRuler && this.state.isShowScaleRuler) {
        this.setState({
          isShowRuler: false,
        });
      }
    });
  };
  //绘制比例尺
  drawScaleRuler = (moveX = 0, moveY = 0, scaleWidth = 0, scaleHeight = 0) => {
    let ruler = document.getElementById("scaleRuler");
    if (!ruler) return;
    if (ruler.getContext) {
      let ctx = ruler.getContext('2d');
      let { clientHeight, clientWidth, paperSpeed, scaleRulerCenterPoint, scaleRulerSize } = this.state;
      //初始化默认宽度为800ms  100像素
      let width = scaleRulerSize[0] + scaleWidth;
      let height = scaleRulerSize[1] + scaleHeight;
      ctx.clearRect(0, 0, clientWidth, clientHeight)
      //中心点坐标
      let centerPointX = scaleRulerCenterPoint[1] ? scaleRulerCenterPoint[0] + moveX : clientWidth / 2 - width / 2 + moveX;
      let centerPointY = scaleRulerCenterPoint[1] ? scaleRulerCenterPoint[1] + moveY : clientHeight / 2 - height / 2 + moveY;
      //一个像素的毫秒数
      let ms = 1000 / (paperSpeed * 5);
      ctx.beginPath();
      ctx.lineWidth = 1.3;
      ctx.strokeStyle = 'blue';
      //以屏幕的中心点，画一个矩形
      // console.log(centerPointX - width / 2, centerPointY - height / 2, width, height, '矩形的位置和值')
      ctx.rect(centerPointX, centerPointY, width, height)
      ctx.stroke();
      ctx.font = "20px Verdana";
      ctx.textAlign = 'center'
      ctx.fillStyle = 'blue'
      ctx.fillText(width * ms + 'ms', centerPointX + width / 2, centerPointY + height + 20)
      ctx.closePath();
      //以中心点矩形为中心，步进为矩形的宽，往两边扩散画标尺
      let left = centerPointX;
      let right = centerPointX + width;
      while ((left > 0 || right < clientWidth) && width > 50) {
        ctx.beginPath();
        ctx.lineWidth = 1.3;
        ctx.moveTo(left, 0)
        ctx.lineTo(left, clientHeight)
        ctx.stroke()
        ctx.moveTo(right, 0)
        ctx.lineTo(right, clientHeight)
        ctx.stroke()
        ctx.closePath();
        left -= width;
        right += width;
      }
      let hoverPosition = {
        x1: centerPointX,
        x2: centerPointX + width,
        y1: centerPointY,
        y2: centerPointY + height
      }
      this.drawScaleImg(ctx, hoverPosition)
      this.changeMouseType(ruler, hoverPosition)
    }
  }
  //获取鼠标在比例尺上的位置
  getEventPosition = (ev) => {
    var x, y;
    if (ev.layerX || ev.layerX === 0) {
      x = ev.layerX;
      y = ev.layerY;
    } else if (ev.offsetX || ev.offsetX === 0) {
      x = ev.offsetX;
      y = ev.offsetY;
    }
    return { x: x, y: y }
  }
  //判断鼠标滑过比例尺的矩形上，鼠标显示十字状态,并且按下可以拖动,鼠标显示小手状态，并且按下可以缩放
  changeMouseType = (ruler, position) => {
    ruler.onmousemove = (e) => {
      let p = this.getEventPosition(e)
      if (p.x > position.x1 && p.x < position.x2 && p.y > position.y1 && p.y < position.y2) {
        //这个是在矩形上
        ruler.style.cursor = 'move'
      } else if (p.x > position.x2 + 5 && p.x < position.x2 + 25 && p.y > position.y2 - 5 && p.y < position.y2 + 15) {
        //这个判断是在缩放图片上
        ruler.style.cursor = 'pointer'
      } else {
        ruler.style.cursor = 'default'
      }
      this.scaleRulerMove(ruler, p, position)
    }
    //鼠标抬起的时候，保存现在的位置和大小
    ruler.onmouseup = (e) => {
      this.setState({
        scaleRulerCenterPoint: [position.x1, position.y1],
        scaleRulerSize: [position.x2 - position.x1, position.y2 - position.y1]
      })
    }
  }
  //比例尺的拖动和缩放
  scaleRulerMove = (ruler, p, position) => {
    ruler.onmousedown = (ev) => {
      let e = ev || window.event;
      let restLeft = e.clientX - ruler.offsetLeft;
      let restTop = e.clientY - ruler.offsetTop;
      //拖动
      if (p.x > position.x1 && p.x < position.x2 && p.y > position.y1 && p.y < position.y2) {
        document.onmousemove = (ev) => {
          let e = ev || window.event;
          let boxLeft = e.clientX - restLeft;
          let boxTop = e.clientY - restTop;
          this.drawScaleRuler(boxLeft, boxTop)
        }
      }
      //缩放
      if (p.x > position.x2 + 5 && p.x < position.x2 + 25 && p.y > position.y2 - 5 && p.y < position.y2 + 15) {
        document.onmousemove = (ev) => {
          let e = ev || window.event;
          let width = e.clientX - restLeft;
          let height = e.clientY - restTop;
          this.drawScaleRuler(0, 0, width, height)
        }
      }
      document.onmouseup = () => {
        //销毁onmousemove和onmouseup事件
        document.onmousemove = null;
        document.onmouseup = null;
      };
      //阻止浏览器默认行为
      return false;
    }
  }
  //绘制可以缩放比例尺的icon
  drawScaleImg = (ctx, position) => {
    let img = new Image()
    img.src = scaleIcon;
    img.onload = () => {
      ctx.drawImage(img, position.x2 + 5, position.y2 - 5, 20, 20)
    }
  }

  //是否显示定标
  changeShowPositionMarkFn = () => {
    this.setState({
      positionMark: !this.state.positionMark
    }, () => {
      if (this.state.positionMark) {
        this.drawPositionMark()
      }
    })
  }
  //绘制定标的相关内容
  drawPositionMark = () => {
    let myCanvas = document.getElementById("positionMark");
    if (myCanvas && myCanvas.getContext) {
      let ctx = myCanvas.getContext("2d");
      let width = myCanvas.width;
      let height = myCanvas.height;
      ctx.clearRect(0, 0, width, height);
      this.drawBigGrid(ctx, width, height, true);
      this.drawAverageLine(ctx, width, height)
    }
  }
  changeActiveLead = (lead) => {
    this.setState({
      averageActiveLead: lead
    }, () => {
      this.drawPositionMark()
    })
  }
  drawAverageLine = (ctx, width, height) => {
    const { averageData } = this.state;
    let obj = {};
    Object.keys(averageData).forEach(item => {
      obj[item] = [];
      for (let i = 0; i < averageData[item].length; i += 2) {
        obj[item].push((hex2int(averageData[item][i + 1].toString(16)) << 8) | (hex2int(averageData[item][i].toString(16)) & 255));
      }
    })
    const drawLine = (arr) => {
      // console.log(arr)
      let { transmission, sampling } = this.state;
      transmission = (20 * 5) / transmission;  //20mm/mv
      let speed = sampling / (50 * 5);  //100mm/s
      let vHeight = height / 2;
      let pointX = width / 2 - 1;
      ctx.beginPath();
      ctx.strokeStyle = "#000";
      ctx.lineWidth = 1.3;
      ctx.lineCap = "square";
      ctx.lineJoin = "round";
      console.log(speed)
      let index = arr.length / 2;
      ctx.moveTo(pointX, vHeight - arr[index] * transmission);
      while (index < arr.length) {
        pointX++;
        ctx.lineTo(pointX, vHeight - arr[index] * transmission)
        index++;
      }
      pointX = width / 2 + 1;
      index = arr.length / 2;
      ctx.moveTo(pointX, vHeight - arr[index + 1] * transmission);
      while (index > 0) {
        pointX--;
        ctx.lineTo(pointX, vHeight - arr[index] * transmission);
        index--;
      }
      // for (let i = 1; i < arr.length; i += speed) {
      //   pointX++;
      //   ctx.lineTo(pointX, vHeight - arr[i] * transmission)
      // }
      ctx.stroke();
      ctx.closePath();
    }
    if (this.state.averageActiveLead === 'ALL') {
      Object.keys(obj).forEach(item => {
        drawLine(obj[item])
      })
    } else {
      console.log(averageData[this.state.averageActiveLead])
      drawLine(obj[this.state.averageActiveLead])
    }
    let myCanvas = document.getElementById("positionMarkTop");
    let context = myCanvas.getContext("2d")
    this.drawAceragePosition(context, width, height);
    myCanvas.onmousedown = null;
    myCanvas.onmousedown = (e) => {
      let restLeft = e.clientX;
      // let restTop = e.clientY;
      let pointX = e.offsetX;
      let pointY = e.offsetY;
      let { markPositionObj } = this.state;
      let obj = this.computerMarkPosition(markPositionObj, width, height);
      let activeMark = this.isClickCanMove(pointX, pointY, obj);

      if (activeMark) {
        document.onmousemove = (e) => {
          let x = e.clientX - restLeft;
          // let y = e.clientY - restTop;
          let entNumber = markPositionObj[activeMark] + x;
          let newObj = Object.assign({}, this.state.markPositionObj, { [activeMark]: entNumber });
          this.setState({
            markPositionObj: newObj,
          }, () => {
            this.drawAceragePosition(context, width, height);
          })
          document.onmouseup = () => {
            document.onmousemove = null;
          }
        }
      }

    }
  }
  drawAceragePosition = (ctx, width, height) => {
    let { markPositionObj } = this.state;
    let markPosition = this.computerMarkPosition(markPositionObj, width, height)
    ctx.clearRect(0, 0, width, height)
    width /= 2;
    ctx.beginPath();
    ctx.strokeStyle = 'blue'
    Object.keys(markPositionObj).forEach(item => {
      ctx.moveTo(width + markPositionObj[item], 0)
      ctx.lineTo(width + markPositionObj[item], height)

    })
    ctx.stroke();
    ctx.closePath()

    Object.keys(markPosition).forEach(item => {
      //方框
      ctx.beginPath();
      ctx.fillStyle = 'blue'
      ctx.fillRect(markPosition[item].x1, markPosition[item].y1, 25, 25)
      ctx.closePath();
      //文字
      ctx.beginPath();
      ctx.font = `18px 微软雅黑`;
      ctx.lineWidth = 0;
      ctx.fillStyle = "#fff";
      ctx.strokeStyle = "red";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(item, markPosition[item].x1 + 13, markPosition[item].y1 + 15)
      ctx.closePath();
    })

  }
  //计算平均波PQRS位置坐标
  computerMarkPosition = (obj, width, height) => {
    height /= 2;
    width /= 2;
    let newObj = {
      P1: { x1: width + obj['PB'], x2: width + obj['PB'] + 25, y1: height - 100, y2: height - 75 },
      P2: { x1: width + obj['PE'], x2: width + obj['PE'] + 25, y1: height - 125, y2: height - 100 },
      Q: { x1: width + obj['QB'], x2: width + obj['QB'] + 25, y1: height - 150, y2: height - 125 },
      S: { x1: width + obj['SE'], x2: width + obj['SE'] + 25, y1: height - 175, y2: height - 150 },
      T1: { x1: width + obj['TB'], x2: width + obj['TB'] + 25, y1: height - 75, y2: height - 50 },
      T2: { x1: width + obj['TE'], x2: width + obj['TE'] + 25, y1: height - 50, y2: height - 25 },
    }
    return newObj
  }
  //判断是否点击在平均波可移动范围
  isClickCanMove = (pointX, pointY, obj) => {
    if (obj.P1.x1 < pointX && obj.P1.x2 > pointX && obj.P1.y1 < pointY && obj.P1.y2 > pointY) {
      return 'PB'
    }
    if (obj.P2.x1 < pointX && obj.P2.x2 > pointX && obj.P2.y1 < pointY && obj.P2.y2 > pointY) {
      return 'PE'
    }
    if (obj.Q.x1 < pointX && obj.Q.x2 > pointX && obj.Q.y1 < pointY && obj.Q.y2 > pointY) {
      return 'QB'
    }
    if (obj.S.x1 < pointX && obj.S.x2 > pointX && obj.S.y1 < pointY && obj.S.y2 > pointY) {
      return 'SE'
    }
    if (obj.T1.x1 < pointX && obj.T1.x2 > pointX && obj.T1.y1 < pointY && obj.T1.y2 > pointY) {
      return 'TB'
    }
    if (obj.T2.x1 < pointX && obj.T2.x2 > pointX && obj.T2.y1 < pointY && obj.T2.y2 > pointY) {
      return 'TE'
    }
    return null
  }

  render() {
    const { paperSpeed, sensitivity, displayModel, vHeight, treeResult, isShowScrollBar, PRIVILEGE, selectEcgLead, printDirection, isShowScaleRuler, positionMark, averageData, averageActiveLead
    } = this.state;
    const {
      rowData,
      form: { getFieldDecorator },
    } = this.props;
    // 走纸速度
    const paperMenu = (
      <Menu onClick={this.handlePaperClick} selectedKeys={[String(paperSpeed)]}>
        <Menu.Item key="12.5">12.5 mm/s</Menu.Item>
        <Menu.Item key="25">25 mm/s</Menu.Item>
        <Menu.Item key="50">50 mm/s</Menu.Item>
      </Menu>
    );

    // 波形增益
    const waveMenu = (
      <Menu onClick={this.handleWaveClick} selectedKeys={[String(sensitivity)]}>
        <Menu.Item key="2.5">2.5 mm/mV</Menu.Item>
        <Menu.Item key="5">5 mm/mV</Menu.Item>
        <Menu.Item key="10">10 mm/mV</Menu.Item>
        <Menu.Item key="20">20 mm/mV</Menu.Item>
      </Menu>
    );

    // 显示模式
    const menu = (
      <Menu
        onClick={this.handleMenuClick}
        selectedKeys={[String(displayModel)]}
        className="menu_wrap"
      >
        <Menu.Item key="1">
          {this.state.ecgLead === 12 ? "12*1" : "18*1"}
        </Menu.Item>
        <Menu.Item key="2">
          {this.state.ecgLead === 12 ? "6*2同步" : "9*2同步"}
        </Menu.Item>
        <Menu.Item key="2.1">
          {this.state.ecgLead === 12 ? "6*2连续" : "9*2连续"}
        </Menu.Item>
        <Menu.Item key="2.11">
          {this.state.ecgLead === 12 ? "6*2+1同步" : "9*2+1同步"}
        </Menu.Item>
        <Menu.Item key="2.111">
          {this.state.ecgLead === 12 ? "6*2+1连续" : "9*2+1连续"}
        </Menu.Item>
        <Menu.Item key="3">
          {this.state.ecgLead === 12 ? "4*3同步" : "6*3同步"}
        </Menu.Item>
        <Menu.Item key="3.1">
          {this.state.ecgLead === 12 ? "4*3连续" : "6*3连续"}
        </Menu.Item>
        <Menu.Item key="3.11">
          {this.state.ecgLead === 12 ? "4*3+1同步" : "6*3+1同步"}
        </Menu.Item>
        <Menu.Item key="3.111">
          {this.state.ecgLead === 12 ? "4*3+1连续" : "6*3+1连续"}
        </Menu.Item>
      </Menu>
    );

    //导联选择
    const ecgLeadmenu = (
      <Menu
        onClick={this.handleEcgLeadClick}
        selectedKeys={[String(selectEcgLead)]}
        className="menu_wrap"
      >
        {this.state.R18.map((item, index) => {
          if (index < this.state.ecgLead) {
            return <Menu.Item key={index}>{item}</Menu.Item>;
          } else {
            return null;
          }
        })}
      </Menu>
    );

    //打印方向
    const printDirectionMap = (
      <Menu
        onClick={this.handleDirectionClick}
        selectedKeys={[String(printDirection)]}
        className="menu_wrap"
      >
        <Menu.Item key="1">横向</Menu.Item>
        <Menu.Item key="2">纵向</Menu.Item>
      </Menu>
    );
    return (
      <div className="ecgStartReportBigBox">
        <div className="tabs_wrap">
          <div>
            <span onClick={this.checkReportView}>
              <Icon type="printer" className="icon" />
              <p>报告打印</p>
            </span>
          </div>
          <div>
            <Dropdown overlay={paperMenu} trigger={["click"]}>
              <span>
                <Icon type="dashboard" className="icon" />
                <p>走纸速度</p>
              </span>
            </Dropdown>
          </div>
          <div>
            <Dropdown overlay={waveMenu} trigger={["click"]}>
              <span>
                <Icon type="line-chart" className="icon" />
                <p>波形增益</p>
              </span>
            </Dropdown>
          </div>
          <div>
            <Dropdown overlay={menu} trigger={["click"]}>
              <span>
                <Icon type="eye" className="icon" />
                <p>显示模式</p>
              </span>
            </Dropdown>
          </div>
          <div>
            <Dropdown overlay={ecgLeadmenu} trigger={["click"]}>
              <span>
                <Icon type="branches" className="icon" />
                <p>导联选择</p>
              </span>
            </Dropdown>
          </div>
          <div>
            <Dropdown overlay={printDirectionMap} trigger={["click"]}>
              <span>
                <Icon type="retweet" className="icon" />
                <p>打印方向</p>
              </span>
            </Dropdown>
          </div>
          <div>
            <span onClick={this.changeShowScaleRulerFn}>
              <img src={scaleRulerIcon} className="icon" alt="" />
              <p>比例尺</p>
            </span>
          </div>
          <div>
            <span onClick={this.changeShowParallelRulerFn}>
              <img src={parallelRulerIcon} className="icon" alt="" />
              <p>平行尺</p>
            </span>
          </div>
          <div>
            <span onClick={this.changeShowPositionMarkFn}>
              <img src={positionIcon} className="icon" alt="" width={28} />
              <p>定标</p>
            </span>
          </div>
        </div>
        <div className="content">
          <div
            className="contentLeft"
            style={{ height: vHeight - 78 }}
            id="ecgCanvas"
          >
            <canvas
              id="ecg"
              width={this.state.clientWidth}
              height={this.state.clientHeight}
            ></canvas>
            <canvas
              id="startPrint"
              width={this.state.clientWidth}
              height={this.state.clientHeight}
            ></canvas>
            {isShowScaleRuler ? (
              <canvas
                id="scaleRuler"
                width={this.state.clientWidth}
                height={this.state.clientHeight}
              ></canvas>
            ) : null}
            {positionMark ?
              <div className="positionMarkBox">
                <div className={Object.keys(averageData).length > 12 ? 'top18' : 'top'}>
                  {Object.keys(averageData).map(item => <p key={item} onClick={this.changeActiveLead.bind(this, item)} className={averageActiveLead === item ? 'active' : ''}>{item}</p>)}
                  <p onClick={this.changeActiveLead.bind(this, 'ALL')} className={averageActiveLead === 'ALL' ? 'active' : ''}>ALL</p>
                </div>
                <canvas id="positionMark" width={600} height={400}></canvas>
                <canvas id='positionMarkTop' width={600} height={400}></canvas>
              </div> : null}
            <div id="changeHeartBox">
              <div className="startTime">
                <p onClick={this.drawStartPoint}>设为开始打印时间</p>
              </div>
              <div className="heartType">
                <span onClick={this.changeHeartFn.bind(this, 0)}>N</span>
                <span onClick={this.changeHeartFn.bind(this, 4)}>S</span>
                <span onClick={this.changeHeartFn.bind(this, 1)}>V</span>
              </div>
            </div>
            {isShowScrollBar ? (
              <div className="scrollBarBox" id="wrap">
                <div id="scrollBar"></div>
              </div>
            ) : null}
            {this.state.isShowRuler ? (
              <img src={ruler} id="ruler" alt="" />
            ) : null}
          </div>
          <div className="contentRight">
            <div className="baseInfo">
              <p>
                <span>姓名：</span>
                {rowData.NAME}
              </p>
              <p>
                <span>编号：</span>
                {rowData.EXAM_UID}
              </p>
              <p>
                <span>年龄：</span>
                {rowData.EXAM_AGE + rowData.AGE_UNIT}
              </p>
              <p>
                <span>性别：</span>
                {rowData.SEX_NAME}
              </p>
              <p>
                <span>记录时间：</span>
                {moment(rowData.EXAM_DATETIME).format("YYYY-MM-DD HH:mm")}
              </p>
            </div>
            <div className="dataInfo">
              <Form layout="inline">
                <FormItem label="心率(bpm)">
                  {getFieldDecorator("HEARTRATE", { initialValue: "" })(
                    <InputNumber />
                  )}
                </FormItem>
                <FormItem label="T波宽度(ms)">
                  {getFieldDecorator("TDURATION", { initialValue: "" })(
                    <InputNumber />
                  )}
                </FormItem>
                <FormItem label="RV5(mV)">
                  {getFieldDecorator("RV5", { initialValue: "" })(
                    <InputNumber />
                  )}
                </FormItem>
                <FormItem label="P波宽度(ms)">
                  {getFieldDecorator("PDURATION", { initialValue: "" })(
                    <InputNumber />
                  )}
                </FormItem>
                <FormItem label="RR间期(ms)">
                  {getFieldDecorator("RRINTERAL", { initialValue: "" })(
                    <InputNumber />
                  )}
                </FormItem>
                <FormItem label="SV1(mV)">
                  {getFieldDecorator("SV1", { initialValue: "" })(
                    <InputNumber />
                  )}
                </FormItem>
                <FormItem label="PR间期(ms)">
                  {getFieldDecorator("PRINTERAL", { initialValue: "" })(
                    <InputNumber />
                  )}
                </FormItem>
                <FormItem label="Rv5+Sv1(mV)">
                  {getFieldDecorator("RV5SV1", { initialValue: "" })(
                    <InputNumber />
                  )}
                </FormItem>
                <div className="widthBox">
                  <FormItem
                    className="twoMobile"
                    label={
                      <span>
                        <span className="textOne">QT</span>
                        <span className="textLine">/</span>
                        <span className="textTwo">QTc</span>
                        <span className="textUnit">间期(ms)</span>
                      </span>
                    }
                  >
                    <span>
                      <FormItem name="QTINTERAL">
                        {getFieldDecorator("QTINTERAL", { initialValue: "" })(
                          <InputNumber />
                        )}
                      </FormItem>
                    </span>
                    {/* &nbsp;/&nbsp; */}
                    <span className="slash">/</span>
                    <span>
                      <FormItem name="QTCINTERAL">
                        {getFieldDecorator("QTCINTERAL", { initialValue: "" })(
                          <InputNumber />
                        )}
                      </FormItem>
                    </span>
                  </FormItem>
                  <FormItem label="QRS波宽度(ms)">
                    {getFieldDecorator("QRSDURATION", { initialValue: "" })(
                      <InputNumber />
                    )}
                  </FormItem>
                  <FormItem
                    className="threeMobile"
                    label={
                      <span>
                        <span className="tOne">P</span>/<span>QRS</span>/
                        <span>T</span>
                        <span className="tUnit">电轴(°)</span>
                      </span>
                    }
                  >
                    <span>
                      <FormItem name="PAXIS">
                        {getFieldDecorator("PAXIS", { initialValue: "" })(
                          <InputNumber />
                        )}
                      </FormItem>
                    </span>
                    <span className="slash">/</span>
                    <span>
                      <FormItem name="QRSAXIS">
                        {getFieldDecorator("QRSAXIS", { initialValue: "" })(
                          <InputNumber />
                        )}
                      </FormItem>
                    </span>
                    <span className="slash">/</span>
                    <span>
                      <FormItem name="TAXIS">
                        {getFieldDecorator("TAXIS", { initialValue: "" })(
                          <InputNumber />
                        )}
                      </FormItem>
                    </span>
                  </FormItem>
                </div>
              </Form>
            </div>
            <div className="reprotBox">
              <Button onClick={this.changeThesaurusFn}>词库</Button>
              {this.state.thesaurusBtn ? (
                <div className="thesaurusBox">
                  <Tree
                    showLine={true}
                    defaultExpandedKeys={["001"]} // 默认展开父元素的一级子元素
                    onSelect={this.selectTreeNodeFn}
                  >
                    {this.renderTreeNodes(treeResult)}
                  </Tree>
                </div>
              ) : null}
              <TextArea
                value={this.state.reportValue}
                onChange={this.changeReportValue}
              ></TextArea>
              {PRIVILEGE === "1" ? (
                <Button onClick={this.startReport}>审核</Button>
              ) : null}
              {PRIVILEGE === "0" ? (
                <Button onClick={this.startReport}>报告</Button>
              ) : null}
            </div>
          </div>
        </div>
        {this.state.reportViewBtn ? (
          <Modal
            visible={this.state.reportViewBtn}
            footer={false}
            onCancel={this.cancalReportView}
            width="100%"
            style={{ top: "-50px", padding: "0" }}
          // title="报告打印"
          >
            <ReportView
              rowData={rowData}
              validateFields={this.props.form.validateFields}
              beatsPosition={this.state.beatsPosition}
              onCancel={this.cancalReportView}
              ecgInfo={{
                ecgLead: this.state.ecgLead,
                reportValue: this.state.reportValue,
                R18: this.state.R18,
                beatArray: this.state.beatArray,
                totalLength: this.state.totalLength,
                second: this.state.second,
                sampling: this.state.sampling,
                transmission: this.state.transmission,
                sensitivity: this.state.sensitivity,
                displayModel: this.state.displayModel,
                paperSpeed: this.state.paperSpeed,
                startSecond:
                  this.state.startSecond > 0 ? this.state.startSecond : 0,
                isContinuity: this.state.isContinuity,
                printDirection: this.state.printDirection,
              }}
            />
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default Form.create()(EcgStartReport);
